import { Link } from 'react-router-dom';

import { ROUTES } from '@/config/routes';
import { landingCopy as copy } from './copy';

/**
 * Closing line of the landing (spec §4.6, restyled to the prototype): one
 * sentence plus a "Tell us about it" link to the Contact page with the
 * support modal open — never a mailto (spec §2 decision 11).
 */
export const LandingFooter = () => (
  <p className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm leading-5 text-muted-foreground">
    {copy.footer.prompt}
    <Link
      to={{ pathname: ROUTES.HELP_CONTACT, search: '?openSupport=true' }}
      className="font-medium text-primary underline-offset-4 hover:underline max-lg:flex max-lg:min-h-11 max-lg:items-center"
    >
      {copy.footer.cta}
    </Link>
  </p>
);
